module.exports = __webpack_public_path__ + "img/kihei.7551d813.jpg";